export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "index.worker.64c896c4316fcd506666.worker.js");
}
